import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import productServices from '../../services/ProductsServices';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { FaEye } from 'react-icons/fa6';
import utils from '../../utils';


function Featured() {
    const [products, setProducts] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const navigate = useNavigate()

    useEffect(() => {
        getFeaturedProducts();
    }, []);

    const getFeaturedProducts = () => {
        setError(null);
        setLoading(true);
        productServices
            .getProducts('?is_featured=1')
            .then(
                (res) => {
                    setProducts(res.data);
                    setLoading(false);
                },
                (err) => {
                    setError(err?.response?.data?.detail || err?.message || 'Failed to load products');
                    setLoading(false);
                }
            );
    };

    if (loading) {
        return (
            <section className="py-9">
                <div className="container mx-auto overflow-hidden px-4">
                    <div className="text-center mb-8">
                        <p className="text-sm font-bold text-secondary uppercase tracking-widest">
                            Customer&apos;s Choice
                        </p>
                        <h2 className="text-3xl md:text-4xl font-black text-gray-900 dark:text-white mt-2">
                            Featured Products
                        </h2>
                        <div className="mt-3 mx-auto w-20 h-1.5 bg-secondary rounded-full"></div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {[1, 2, 3, 4].map((i) => (
                            <div
                                key={i}
                                className="rounded-lg overflow-hidden bg-white shadow-lg animate-pulse"
                            >
                                <div className="w-full h-48 bg-gray-300"></div>
                                <div className="p-6 bg-gray-800 h-32">
                                    <div className="h-6 bg-gray-700 rounded w-3/4 mb-4"></div>
                                    <div className="h-10 bg-gray-700 rounded w-32"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section >
        );
    }

    if (error) {
        return (
            <section className="py-9">
                <div className="container mx-auto px-4">
                    <div className="text-center">
                        <p className="text-red-500 font-semibold">{error}</p>
                        <button
                            onClick={getFeaturedProducts}
                            className="mt-4 bg-secondary text-white px-6 py-2 rounded-lg hover:bg-orange-600 transition"
                        >
                            Try Again
                        </button>
                    </div>
                </div>
            </section>
        );
    }

    if (!products?.results?.length) {
        return (
            <div className="">
                {/* <section className="py-9">
                    <div className="container mx-auto px-4">
                        <div className="text-center">
                            <p className="text-gray-500 font-semibold">No featured products available</p>
                        </div>
                    </div>
                </section> */}
            </div>
        );
    }

    return (
        <section className="pt-2">
            <div className="container mx-auto overflow-hidden">
                <div className="text-center mb-8">
                    <p className="text-sm font-bold text-secondary uppercase tracking-widest">
                        Customer&apos;s Choice
                    </p>
                    <h2 className="text-3xl md:text-4xl font-black text-gray-900 dark:text-white mt-2">
                        Don’t Miss These.
                    </h2>
                    <div className="mt-3 mx-auto w-20 h-1.5 bg-secondary rounded-full"></div>
                </div>
                <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={14}
                    slidesPerView={2}
                    navigation
                    autoplay={{
                        delay: 4500,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }}
                    speed={600}
                    breakpoints={{
                        640: { slidesPerView: 2, spaceBetween: 20 },
                        768: { slidesPerView: 3, spaceBetween: 24 },
                        1024: { slidesPerView: 4, spaceBetween: 32 },
                    }}
                    className="pb-6 w-full"
                    style={{ maxWidth: '96vw' }}
                >
                    {products.results.map((product) => (
                        <SwiperSlide key={product.id || product.slug}>
                            <div className="group rounded-lg overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                                <div
                                    onClick={() => navigate(`/product/${product.slug}`)}
                                    className="relative overflow-hidden">
                                    <img
                                        alt={product.name}
                                        className="w-full h-36 lg:h-64 object-cover transition-transform duration-500 group-hover:scale-110"
                                        src={product.image}
                                    />
                                    {product?.is_featured ? (
                                        <span className="absolute top-3 left-3 bg-gradient-to-r from-primary to-secondary text-white text-[10px] font-bold px-3 py-1 rounded-full uppercase z-10 shadow-lg">
                                            Featured
                                        </span>
                                    ) : product?.price >= 4000 ? (
                                        <span className="absolute top-3 left-3 bg-gradient-to-r from-accent to-info text-white text-[10px] font-bold px-3 py-1 rounded-full uppercase z-10 shadow-lg">
                                            Premium
                                        </span>
                                    ) : null}
                                    <Link
                                        to={`/product/${product?.slug}`}
                                        className="absolute top-3 right-3 w-9 h-9 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center text-gray-800 hover:bg-secondary hover:text-white transition-all opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 shadow-md z-10"
                                    >
                                        <FaEye className="w-4 h-4" />
                                    </Link>
                                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300"></div>
                                </div>
                                <div className="p-3 lg:p-6 text-xs md:text-base bg-gray-800 dark:bg-slate-800 text-white flex flex-col items-start transition-colors duration-300 group-hover:bg-gray-900">
                                    <h3
                                        className="font-bold text-sm text-start w-full truncate"
                                    >
                                        {product?.name}
                                    </h3>
                                    <p className="text-secondary font-bold mt-auto">
                                        KES {utils.toCommas(product?.price || 0)}
                                    </p>
                                    <Link
                                        className="mt-3 lg:mt-4 inline-block bg-secondary text-center text-xs w-full text-white font-bold lg:py-2.5 py-1.5 lg:px-6 px-3 rounded-lg hover:bg-orange-600 hover:shadow-lg transition-all duration-300 transform hover:scale-105"
                                        to={`/product/${product.slug}`}
                                    >
                                        VIEW PRODUCT
                                        <span className="group-hover/btn:translate-x-1 transition-transform duration-300 ml-2">→</span>
                                    </Link>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
}

export default Featured;